









































import Vue from "vue"
import request from "../lib/request"
import {StoryInfo} from '../lib/story-utils';
import {RunnerInfo} from "../lib/runner-utils";

interface StorySummary {
  name: string,
  summary: string,
  info: StoryInfo,
  runners: RunnerInfo[]
}

export default Vue.extend({
  data() {
    return {
      stories: <StorySummary[]>[]
    }
  },

  created() {
    this.fetchData()
  },

  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData() {
      request.getStories()
        .then(result => {

          let stories: StorySummary[] = []

          result.forEach((item: [string, StoryInfo]) => {

            let [storyName, storyInfo] = item

            let summary: string[] = [];
            summary.push(`<span class="tag is-success">${storyInfo.source.type} Source</span>`)

            storyInfo.transforms.forEach(trans =>
              summary.push(`<span class="tag is-light">${trans.type} Transform</span>`))

            summary.push(`<span class="tag is-primary">${storyInfo.sink.type} Sink</span>`)

            if (storyInfo.fallback) {
              summary.push(`<span class="tag is-warning">${storyInfo.fallback.type} Fallback</span>`)
            }

            request.getStoryRunners(storyName).then(runners => {
              stories.push({
                name: storyName,
                summary: summary.join(' -> '),
                info: storyInfo,
                runners: runners
              })
            })

          })

          this.stories = stories

        })
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stories.vue